/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Remove_Failed_ToastInputs */

const en_style_guide_manager_remove_failed_toast = /** @type {(inputs: Style_Guide_Manager_Remove_Failed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to delete style guide:`)
};

const fr_style_guide_manager_remove_failed_toast = /** @type {(inputs: Style_Guide_Manager_Remove_Failed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Echec de la suppression du guide de style :`)
};

const de_style_guide_manager_remove_failed_toast = /** @type {(inputs: Style_Guide_Manager_Remove_Failed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fehler beim Löschen des Styleguides:`)
};

const it_style_guide_manager_remove_failed_toast = /** @type {(inputs: Style_Guide_Manager_Remove_Failed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossibile eliminare la guida di stile:`)
};

const ru_style_guide_manager_remove_failed_toast = /** @type {(inputs: Style_Guide_Manager_Remove_Failed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не удалось удалить руководство по стилю:`)
};

const es_style_guide_manager_remove_failed_toast = /** @type {(inputs: Style_Guide_Manager_Remove_Failed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo eliminar la guía de estilo:`)
};

const zh_cn2_style_guide_manager_remove_failed_toast = /** @type {(inputs: Style_Guide_Manager_Remove_Failed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`删除样式指南失败：`)
};

const ja_style_guide_manager_remove_failed_toast = /** @type {(inputs: Style_Guide_Manager_Remove_Failed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スタイル ガイドの削除に失敗しました:`)
};

const hi_style_guide_manager_remove_failed_toast = /** @type {(inputs: Style_Guide_Manager_Remove_Failed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्टाइल गाइड को हटाने में विफलता:`)
};

const pt_pt2_style_guide_manager_remove_failed_toast = /** @type {(inputs: Style_Guide_Manager_Remove_Failed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Falha ao excluir o guia de estilo:`)
};

/**
* | output |
* | --- |
* | "Failed to delete style guide:" |
*
* @param {Style_Guide_Manager_Remove_Failed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_remove_failed_toast = /** @type {((inputs?: Style_Guide_Manager_Remove_Failed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Remove_Failed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_style_guide_manager_remove_failed_toast(inputs)
	if (locale === "de") return de_style_guide_manager_remove_failed_toast(inputs)
	if (locale === "it") return it_style_guide_manager_remove_failed_toast(inputs)
	if (locale === "ru") return ru_style_guide_manager_remove_failed_toast(inputs)
	if (locale === "es") return es_style_guide_manager_remove_failed_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_style_guide_manager_remove_failed_toast(inputs)
	if (locale === "ja") return ja_style_guide_manager_remove_failed_toast(inputs)
	if (locale === "hi") return hi_style_guide_manager_remove_failed_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_style_guide_manager_remove_failed_toast(inputs)
	return en_style_guide_manager_remove_failed_toast(inputs)
});